export interface LocationNode {
  readonly id: string;
  readonly warehouseId: string;
  readonly parentId: string | null;
  readonly path: string;
  readonly depth: number;
  readonly code: string | null;
  readonly name: string;
  readonly typeId: string | null;
  readonly description: string | null;
  readonly canStoreInventory: boolean;
  readonly sortOrder: number;
  readonly status: 'ACTIVE' | 'ARCHIVED';
  readonly version: number;
}

export interface LocationTypeItem {
  readonly id: string;
  readonly code: string;
  readonly nameKey: string;
  readonly icon: string | null;
  readonly defaultCanStore: boolean;
  readonly sortOrder: number;
}

export interface BreadcrumbItem {
  readonly id: string;
  readonly name: string;
  readonly typeId: string | null;
}

/** 树形组件复用的内存结构：按 parentId 分组的子节点索引 */
export function buildChildrenIndex(
  nodes: readonly LocationNode[],
): Map<string | null, LocationNode[]> {
  const index = new Map<string | null, LocationNode[]>();
  for (const node of nodes) {
    const key = node.parentId;
    const list = index.get(key) ?? [];
    list.push(node);
    index.set(key, list);
  }
  for (const list of index.values())
    list.sort((a, b) => a.sortOrder - b.sortOrder || a.name.localeCompare(b.name));
  return index;
}
